module.exports = __webpack_public_path__ + "static/media/5ed7a2cf72f4e5e57a748789.5c0033f8.png";